import PropTypes from "prop-types";
import React from "react";
import {
  repositories,
  courses,
  adminPolicies,
  content
} from "../../routes/AdminRoutes";
import { Route, Redirect } from "react-router-dom";
import AdminContentRepositories from "./AdminContentRepositories";
import AdminContentCourses from "./AdminContentCourses";
import AdminContentPolicies from "./AdminContentPolicies";

export default function AdminContent(props) {
  return (
    <>
      <Route path={content} exact render={() => <Redirect to={courses} />} />
      <Route path={repositories} component={AdminContentRepositories} />
      <Route path={courses} component={AdminContentCourses} />
      <Route path={adminPolicies} component={AdminContentPolicies} />
    </>
  );
}

AdminContent.propTypes = {
  match: PropTypes.any
};
